/** Groups tasks into daily sections (overdue, today, upcoming) and calculates total work duration for each. */
import { useDailySectionBuckets } from '@/features/tasks/hooks/list/use-list-daily-sections-buckets';
import {
  useDailySectionDerived,
  buildDailySectionDurations,
} from '@/features/tasks/hooks/list/use-list-daily-sections-derived';

/**
 * Derives all task section data for TodayView from filteredTasks, nextActions,
 * and the active focus task ID. Encapsulates all useMemo categorisation logic.
 *
 * @param {Object} params
 */
const useDailyTaskSections = ({
  filteredTasks,
  nextActions,
  activeFocusTaskId,
  tasksMap = new Map(),
}) => {
  const { overdueTasks, todayTasks, completedTodayTasks, upcomingTasks } =
    useDailySectionBuckets(filteredTasks, tasksMap);

  const derived = useDailySectionDerived({
    overdueTasks,
    todayTasks,
    upcomingTasks,
    nextActions,
    activeFocusTaskId,
    filteredTasks,
  });

  const durations = buildDailySectionDurations({
    todayTasks,
    completedTodayTasks,
    nextActions,
    overdueTasks,
    upcomingTasks,
    tasksMap,
  });

  return {
    overdueTasks,
    todayTasks,
    completedTodayTasks,
    upcomingTasks,
    ...derived,
    ...durations,
  };
};

export default useDailyTaskSections;
